import { NgModule } from '@angular/core';
import { NavigationComponent} from './navigation.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    NavigationComponent,
  ],
  imports: [
    FormsModule,
    CommonModule
  ],
  exports: [
    NavigationComponent,
  ]
})
export class NavigationModule { }